<template>
  <div>
    <div class="modal-header">
      <h2>Upozorenje</h2>
    </div>
    <div class="modal-body">
      <p>
        Da li ste sigurni da želite da obrišete korisnika:
        {{ this.$store.state.modal.virtualMember.full_name }}?
      </p>
    </div>
    <hr />
    <div class="footer">
      <button
        type="submit"
        class="btn btn-default btn--mod close-btn"
        @click="closeModal"
      >
        Otkaži
      </button>
      <button
        type="submit"
        class="btn btn-danger btn--mod"
        @click="deleteVirtualMember"
        :disabled="loading"
      >
        <p v-if="!loading">Obriši</p>
        <spinner :size="20" line-fg-color="#610d0d" v-if="loading" />
      </button>
    </div>
  </div>
</template>

<script>
import { financesInstance } from '@/axios/axios.js';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  computed: {
    ...mapState('modal', ['transaction']),
    ...mapState('finances', ['transactions'])
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    ...mapMutations('table', ['setTableData']),
    ...mapMutations('modal', ['closeModal', 'showModal']),
    ...mapActions('table', ['getTableData']),
    ...mapActions('modal', [
      'showSuccessModal',
      'showFailModal',
      'removeVirtualMemberList'
    ]),
    async deleteVirtualMember() {
      if (this.loading) {
        return;
      }

      this.loading = true;
      const virtualMember = this.$store.state.modal.virtualMember;
      let virtualMembers = this.$store.state.modal.virtualMemberList;

      financesInstance
        .delete(`members/${virtualMember.id}`)
        .then(async () => {
          virtualMembers = virtualMembers.filter(function(obj) {
            return obj.id !== virtualMember.id;
          });
          this.setTableData(virtualMembers);
          this.removeVirtualMemberList();
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(() => {
          this.showFailModal();
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.close-btn {
  margin-right: 4px;
}

.btn--mod {
  height: 35px;
  min-width: 75px;
  margin-left: 5px;
  align-self: center;
}
</style>
